module.exports = __webpack_public_path__ + "img/Aviation_sus_1.cefc711e.jpg";